<template>
    <Grid/>
</template>

<script>
    import Grid from './../components/Program/POA/components/Evaluation/Middle/Grid'

    export default {
        components: {
            Grid,
        }
    }
</script>